/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { NbCardModule, NbIconModule, NbInputModule, NbSpinnerModule, NbThemeModule, NbTreeGridModule } from '@nebular/theme';
import { OrderModule } from 'ngx-order-pipe';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

import { ServiceUtils } from './_helpers/service.utils';
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { MatDialogModule } from '@angular/material/dialog';


import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { LoginComponent } from './login/login.component';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { SsoComponent } from './sso/sso.component';
import { CaseBookingService } from './_services';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';
import { FontPickerModule } from 'ngx-font-picker';
import { FONT_PICKER_CONFIG } from 'ngx-font-picker';
import { FontPickerConfigInterface } from 'ngx-font-picker';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PwdChangeComponent } from './pwd-change/pwd-change.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DroplocationComponent } from './droplocation/droplocation.component';
import { ShareMyLocationComponent } from './share-my-location/share-my-location.component';
import { FeedBackComponent } from './feed-back/feed-back.component';
//import { MfaPopupComponent } from './src/app/mfa-popup/mfa-popup.component';
import { MaterialModule } from './material.module';
const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
  // Change this to your Google API key
  apiKey: 'AIzaSyA9S7DY0khhn9JYcfyRWb1F6Rd2rwtF_mA'
};
///new datepicker changes

//import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
@NgModule({

  declarations: [AppComponent, LoginComponent, SsoComponent, TermsAndConditionsComponent, PwdChangeComponent, ForgotPasswordComponent, DroplocationComponent, FeedBackComponent, ShareMyLocationComponent],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    OrderModule,
    ReactiveFormsModule,
    FormsModule,
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    Ng2SmartTableModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forChild(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbThemeModule,
    FontPickerModule,
    ColorPickerModule,
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbSpinnerModule,
    GooglePlaceModule,
    LoggerModule.forRoot({
      //serverLoggingUrl: '/logs',
      level: NgxLoggerLevel.DEBUG,
      context: 'context',
      enableSourceMaps: true
      //serverLogLevel: NgxLoggerLevel.ERROR
    }),
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    MaterialModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ServiceUtils, CaseBookingService,
    {
      provide: APP_INITIALIZER,
      useFactory: (serviceUtils: ServiceUtils, caseService: CaseBookingService) => () => {
        console.log("Called App iniitalizer");
        serviceUtils.loadDRSACities();
        serviceUtils.getClientDefaults();
      },
      deps: [ServiceUtils, CaseBookingService],
      multi: true
    },
    {
      provide: FONT_PICKER_CONFIG,
      useValue: DEFAULT_FONT_PICKER_CONFIG
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
}
